import { FC, useState } from 'react';
import { Button, Icon } from 'common-components';
import { RadioButtonProps, RadioButtonsCardProps } from './radioButtonsCardTypes';
import styles from './radioButtonsCard.module.scss';
import Tooltip from '../tooltip';

const RadioButtonsCard: FC<RadioButtonsCardProps> = (props: RadioButtonsCardProps) => {
    const [selectedButton, setSelectedButton] = useState<number>(props.selectedButton || 0);

    const { title, buttons } = props;

    const onButtonClick = (index: number, clickCallback?: Function) => {
        setSelectedButton(index);
        clickCallback?.();
    };

    const getWarningMessage = () => {
        return (
            <div className={styles.wrapper}>
                <Icon name="warningYellow" className={styles.icon} />
                <div className={styles['title-wrapper']}>
                    <div className={styles.title}>{props.warrningMessageTitle}</div>
                    <div className={styles.sub}>{props.warrningMessageSubTitle}</div>
                </div>
            </div>
        );
    };

    const renderButton = (index: number, button: RadioButtonProps) => {
        const isClickActive = button.isClickActive !== undefined ? button.isClickActive : true;
        return (
            <Button
                type={selectedButton === index ? 'purpleStatic' : 'purple'}
                text={button.text}
                wrapperClassName={'assigned-content-button-wrapper'}
                className={isClickActive ? '' : styles['disabled-button']}
                lowerCase
                onClick={isClickActive ? () => onButtonClick(index, button.clickCallback) : undefined}
            />
        );
    };

    return (
        <div className={styles['radio-buttons-card-wrapper']}>
            {title && (
                <span className={styles.title} data-testid="radio-buttons-card-title">
                    {title}
                </span>
            )}
            <div className={styles['buttons-wrapper']} data-testid="radio-buttons-card-buttons">
                {buttons.map((button, index) => {
                    const isTooltipButton = button.isClickActive === false;
                    return (
                        <div key={index}>
                            {isTooltipButton ? (
                                <Tooltip
                                    type="purple"
                                    minWidth="20rem"
                                    maxWidth="28rem"
                                    placement={'top-end'}
                                    title={getWarningMessage()}
                                >
                                    <div>{renderButton(index, button)}</div>
                                </Tooltip>
                            ) : (
                                renderButton(index, button)
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RadioButtonsCard;
